import { useRef } from "react"
import { useNavigate } from "react-router-dom"
import { enqueueSnackbar } from "notistack"
import { FormikProps } from "formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { PosSettingQuery, createTemplate } from "../supplierPosSettingsApi"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { SUPPLIER_ADMIN_POS_SETTINGS_ROUTE, SUPPLIER_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { CreateUpdateTemplateForm } from "../components/CreateUpdateTemplateForm"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { CreateUpdateTemplateFormValues } from "../supplierPosSettingsTypes"
import { useCurrentSupplier } from "../../../../../suppliers/supplierHooks"
import { prepareInitialValues } from "../helpers/prepareInitialValues"

export function CreateTemplatePage() {
    const navigate = useNavigate()
    const { supplierId } = useCurrentSupplier()

    const templateFormRef = useRef<FormikProps<CreateUpdateTemplateFormValues>>(null)

    const handleSaveClick = () => {
        templateFormRef.current?.submitForm()
    }

    const { mutate: callCreateTemplate } = useApiMutation(createTemplate, {
        async onSuccess(_, data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [PosSettingQuery.TEMPLATES_LIST] })
            navigate(SUPPLIER_ADMIN_POS_SETTINGS_ROUTE)

            if (!data.serviceResponse.displayMessage) return
            enqueueSnackbar({
                variant: "success",
                message: data?.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="supplier-admin-pos-settings-create-template-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPLIER_ADMIN_POS_SETTINGS_CREATE}
                    title="Create template"
                    rightElement={
                        <LocalizedStrict id="supplier-admin-pos-settings-create-submit-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="supplier-nav-item-home">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-settings">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-pos-settings">
                            <BreadcrumbLink to={SUPPLIER_ADMIN_POS_SETTINGS_ROUTE}>POS settings</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-admin-nav-item-pos-settings-template-create">
                            <Breadcrumb>Create template</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateTemplateForm
                ref={templateFormRef}
                initialValues={prepareInitialValues()}
                onSubmit={(data) => {
                    callCreateTemplate({ template: data, supplierId })
                }}
            />
        </>
    )
}
